import { render, staticRenderFns } from "./mhao_order_item.vue?vue&type=template&id=7f0535f4&scoped=true"
import script from "./mhao_order_item.vue?vue&type=script&lang=js"
export * from "./mhao_order_item.vue?vue&type=script&lang=js"
import style0 from "./mhao_order_item.vue?vue&type=style&index=0&id=7f0535f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0535f4",
  null
  
)

export default component.exports